export const environment = {
  production: true,
  name: 'production',
  version: '',
  baseUrl: 'https://apotecacommunity.loccioni.com',
  externalWelcomeUrl: 'http://www.apotecacommunity.com/release/',
  externalResetPasswordSuccessUrl: 'http://www.apotecacommunity.com/installation/'
};
